import styled, { css } from 'styled-components/macro';
import { colorBlackTransparent100, colorBlackTransparent300, colorCoreBlack300, colorCoreBlack900Base, colorCoreWhite1000, colorWhiteTransparent100, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { INDENT } from '@yme/tokens/sizes';
import { letterSpacingS, textUpperCase } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
const getColors = (isLight) => {
    if (isLight) {
        return css `
      background-color: ${colorCoreWhite1000};
      border: 1px solid ${colorBlackTransparent300};
      color: ${colorCoreBlack300};
    `;
    }
    return css `
    background-color: ${colorCoreBlack900Base};
    border: 1px solid ${colorWhiteTransparent100};
    color: ${colorCoreWhite1000};

    &:hover {
      background-color: ${colorWhiteTransparent100};
    }
  `;
};
export const LanguageSelectorButtonStyled = styled.button `
  ${getTextStyles('Ubuntu', 400, 14, 20)};
  ${letterSpacingS};
  ${textUpperCase};

  text-align: center;
  box-sizing: border-box;
  cursor: pointer;

  display: flex;
  white-space: normal;
  justify-content: center;
  align-items: center;
  gap: 6px;

  padding: 8px 16px 8px 8px;
  text-transform: capitalize;

  border-radius: ${CORNER_RADIUS.s};
  direction: ${({ isRightToLeft }) => (isRightToLeft ? 'rtl' : 'ltr')};

  ${({ isLight }) => getColors(isLight)};

  & > span {
    align-items: center;
    text-align: center;
    justify-content: center;

    & > svg {
      width: 16px;
      height: 16px;
    }
  }
`;
export const LanguageSelectorMinifiedButtonStyled = styled.button `
  width: 40px;
  height: 40px;
  padding: ${INDENT.xxxs};
  border-radius: 50%;
  border: none;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    background-color: ${colorBlackTransparent100};
  }
`;
